// An anonymous id for this browser, sent to the server as X-Visitor-Id. The server uses it (with the account, once logged in) to know
// whose early-bird window a request belongs to. It identifies a browser, not a person, and carries nothing else.
const KEY = 'bvVisitorId';
const PATTERN = /^[A-Za-z0-9_-]{8,64}$/;
let inMemory = '';

const newId = () => {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
};

export const getVisitorId = () => {
  try {
    const saved = window.localStorage.getItem(KEY);
    if (saved && PATTERN.test(saved)) return saved;
    const id = newId();
    window.localStorage.setItem(KEY, id);
    return id;
  } catch (error) {
    // storage blocked (private window): the id lasts until the page is closed, and the server falls back to the network address
    if (!inMemory) inMemory = newId();
    return inMemory;
  }
};

export const visitorHeaders = () => ({ 'X-Visitor-Id': getVisitorId() });
